import * as angular from 'angular';

angular.module('app').filter('status', status);

function status(utility) {
	return function (value) {
		return utility.capitalize(utility.breakCamelCaseWords(value));
	};
}
